import { GzExchangeAntimalwareExclusionsFormWebComponent } from './component/GzExchangeAntimalwareExclusionsFormWebComponent';

export { GzExchangeAntimalwareExclusionsFormWebComponent };
